import {Palette} from 'hubbl-shared';
import {AssetIconProps} from '../types';
import {memo} from 'react';

export const AssetIconClose = memo(
  ({size = 24, color = Palette.almostBlack}: AssetIconProps) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7 16.8995L16.8995 7.00004"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M7 7L16.8995 16.8995"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  },
);
